import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { max } from "moment";
import { MatRadioButton, MatRadioGroup, MatRadioModule } from "@angular/material/radio";
import { FormsModule } from "@angular/forms";
import { OvenDashboardComponent } from '../oven-dashboard/oven-dashboard.component';
// import { DialogThresholdSettingsComponent } from '../../eBoiler/dialog-threshold-settings/dialog-threshold-settings.component';

@Component({
  selector: 'app-threshold-dial-box',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './threshold-dial-box.component.html',
  styleUrl: './threshold-dial-box.component.scss'
})
export class ThresholdDialBoxComponent {
  public disableBtn: boolean = false;
    public changedData: any = [];
    changedObjects: any[] = [];
    metric_type: any;
    public saveButton: boolean = false;
    public applicationName = localStorage.getItem("ApplicationName");
    public clientName = localStorage.getItem("company_name");
    public siteName = localStorage.getItem("SiteName");
    public mac_address = localStorage.getItem("MacAddress");
    public thresholdArray: any;
    public serial_number = "Not assign";
    public updated_obj: any = {};
    public commentText: string;
    public supervisor_name: string=null;
    constructor(
      public dialogRef: MatDialogRef<OvenDashboardComponent>,
      private service: BackendApiService,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
      console.log(data,'data');
      this.thresholdArray = this.data.dataAll.map(item => ({ ...item }));
    }
  
    ngOnInit(): void {}
    onSave(): void {
      const dataArray = [
        {
          index: 0,
          changedObject: this.data,
        },
      ];
      // Call a function to save the data
      this.dialogRef.close(dataArray); // Pass modified data back to parent component
    }
    saveMetricsData() {
      if(!this.supervisor_name || !this.commentText){
        this.service.showError('Please enter comment box and supervisor name')
        return;
      }
      let th1Err = false;
      let th2Err = false;
      //check for threshold 2
      console.log(this.data.dataAll,'sssssssssss')
      for (let i = 0; i < this.data.dataAll.length; i++) {
        const {
          threshold_1,
          threshold_2,
          threshold_3,
          metric_name,
          base_value,
          max_value,
          orieX_default,
          orieY_default,
          orieZ_default,
          max_counter
        } = this.data.dataAll[i];
        console.log(threshold_1, threshold_2, threshold_3, base_value, max_value,max_counter,orieX_default);
        if (base_value == null) {
          this.service.showError(
            `Base value should not be empty in Range`
          );
          th1Err = true;
          break;
        }
        if(max_counter=='' || max_counter==' ' || max_counter==null || max_counter==undefined){
          this.service.showError("Please enter valid counter value!")
          th1Err = true;
          th2Err = true;
          break;
        }
        if (max_value == null) {
          this.service.showError(
            `Max value should not be empty in Range`
          );
          th1Err = true;
          th2Err = true;
          break;
        }
        if (threshold_1 === null) {
          this.service.showError(`Under-Red  should not be empty`);
          th1Err = true;
          th2Err = true;
          break;
        }
        if (threshold_2 == null) {
          this.service.showError(`under-Yellow should not be empty`);
          th2Err = true;
          break;
        }
        if (threshold_1 >= threshold_2) {
          this.service.showError(
            `Under-Red should be less than Under-Yellow`
          );
          th1Err = true;
          break;
        }
      
         else if (threshold_1 >= threshold_3) {
          this.service.showError(
            `Under-Red should be less than Under-Green`
          );
          th1Err = true;
          break;
        }
        //check for threshold 2
        if (threshold_2 >= threshold_3) {
          this.service.showError(
            `Under-Yellow should be less than Under-Green`
          );
          th2Err = true;
          break;
        } else if (threshold_2 <= threshold_1) {
          this.service.showError(
            `Under-Yellow should be more than Under-Red`
          );
          th2Err = true;
          break;
        }
        else if (threshold_3 <= threshold_2) {
          console.log(threshold_3,threshold_2,'wwwwwwwwww')
          this.service.showError(
            `Under-Green should be more than Under-yellow`
          );
          th2Err = true;
          break;
        }
        else if (threshold_3 >= orieX_default) {
          console.log(threshold_3, orieX_default)
          this.service.showError(
            `Under-Green should be less than Over-Green`
          );
          th2Err = true;
          break;
        }
        else if (orieX_default >= orieY_default) {
          this.service.showError(
            `Over-Green should be less than Over-Yellow`
          );
          th2Err = true;
          break;
        }
        else if (orieY_default <= orieX_default) {
          this.service.showError(
            ` Over-Yellow should be greater than Over-green`
          );
          th2Err = true;
          break;
        }
       
        else if (orieX_default >= orieY_default) {
          this.service.showError(
            `Over-Green should be less than Under-Yellow`
          );
          th2Err = true;
          break;
        }
        else if (orieY_default >= orieZ_default) {
          this.service.showError(
            `Over-Yellow should be less than Under-Red`
          );
          th2Err = true;
          break;
        }
        
        //check for range
        if (base_value >= max_value) {
          this.service.showError(
            `Base value should be less than max value in Range`
          );
          th1Err = true;
          break;
        } else if (max_value < base_value) {
          this.service.showError(
            `Max value should be more than base value in Range`
          );
          th1Err = true;
          break;
        }
      }
      console.log(th1Err,th2Err,'ddddddddddddddddddd');
      if (th1Err || th2Err) return;
      else {
         let object = {
        application: this.applicationName,
        belong_to: "null",
        by_user: 1,
        client: this.clientName,
        mac_address: this.mac_address,
        module: "EDIT Threshold SETTINGS",
        serial_number: this.serial_number,
        site: this.siteName,
        updated_obj:JSON.stringify(this.updated_obj) 
      }
        const mergedData = {
        changedObjects: this.changedObjects,
        comment: this.commentText,
        supervisor_name:this.supervisor_name
      };
        console.log(mergedData,'changeobjects');

        this.dialogRef.close(mergedData);
      }
    }
    updateData(event: Event, index: number) {
      this.saveButton = true;
      const inputElement = event.target as HTMLInputElement;
      this.metric_type = this.data.dataAll[index][inputElement.name];
      this.updated_obj["metric_label"] = this.thresholdArray[index]["metric_label"];
      this.updated_obj[`old_${inputElement.name}`] = this.thresholdArray[index][inputElement.name];
      this.updated_obj[`new_${inputElement.name}`] = this.data.dataAll[index][inputElement.name];


      const inputValue = inputElement.value.trim();
      let newValue =0;
      if(inputElement.name !== "metric_label"){
        newValue = parseInt(inputValue, 10);
        // Handle invalid input (e.g., empty or non-numeric values)
        if (isNaN(newValue)) {
          this.service.showError(`${this.metric_type}: Please enter a valid number`);
          inputElement.value = inputValue; // Preserve existing user input for correction
          return;
        }
      }
      
  
      const thresholds = this.data.dataAll[index];
      // Validation logic
      switch (inputElement.name) {
        case "threshold_1":
          if (newValue >= thresholds.threshold_2) {
            thresholds.threshold_1 = thresholds.threshold_2 - 1;
            inputElement.value = thresholds.threshold_1.toString();
            this.service.showError(`${this.metric_type}: Green should be less than Yellow`);
          } else if (newValue <= 0) {
            thresholds.threshold_1 = 1;
            inputElement.value = "1";
            this.service.showError(`${this.metric_type}: Value must be positive`);
          } else {
            thresholds.threshold_1 = newValue;
          }
          break;
    
        case "threshold_2":
          if (newValue <= thresholds.threshold_1) {
            thresholds.threshold_2 = thresholds.threshold_2;
            inputElement.value = thresholds.threshold_2.toString();
            this.service.showError(`${this.metric_type}: Yellow should not less than green`);
          } else if (newValue <= 0) {
            thresholds.threshold_2 =  thresholds.threshold_2.toString();
            inputElement.value = "1";
            this.service.showError(`${this.metric_type}: Value must be positive`);
          } else {
            thresholds.threshold_2 = newValue;
          }
          break;
    
        case "base_value":
          if (newValue < 0) {
            thresholds.base_value = 0;
            inputElement.value = thresholds.base_value.toString();
            this.service.showError(`${this.metric_type}: Value must be at least 0`);
          }  else {
            thresholds.base_value = newValue;
          }
          break;
    
        case "max_value":
          if (newValue <= thresholds.base_value) {
            thresholds.max_value = thresholds.base_value + 1;
            inputElement.value = thresholds.max_value.toString();
            this.service.showError(`${this.metric_type}: Range end must be greater than range start`);
          }
          //  else if (newValue >= thresholds.threshold_3) {
          //   thresholds.max_value = thresholds.threshold_3 - 1;
          //   inputElement.value = thresholds.max_value.toString();
          //   this.service.showError(`${this.metric_type}: Range end must be less than Red`);
          // }
          else {
            thresholds.max_value = newValue;
          }
          break;
    
        case "counter":
          thresholds.max_counter = newValue;
          break;
        default:
          // this.service.showError(`${this.metric_type}: Invalid field`);
      }
     
    // Track changes
      const changedObject = { ...thresholds };
      const existingIndex = this.changedObjects.findIndex((obj) => obj.index === index);
  
    if (existingIndex !== -1) {
      this.changedObjects[existingIndex] = { index, changedObject };
    } else {
      console.log(changedObject,'changovjejeej')
      this.changedObjects.push({ index, changedObject });
    }
  }

  addComment(event){
    let input = event.target as HTMLTextAreaElement;
    this.saveButton = true;
    this.commentText = input.value;
  }

  setSuperVisor(event:any){
    this.supervisor_name=event.target.value
  }
  
    
    
    
    onClose(): void {
      this.dialogRef.close();
    }
}
